import { render, staticRenderFns } from "./ConvenioHome.vue?vue&type=template&id=218561c2"
import script from "./ConvenioHome.vue?vue&type=script&lang=js"
export * from "./ConvenioHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports